import { formatBytes } from '@utils/upload-arquivo';
import { IUploadDocumentoPreviewTrabalhador } from '../../models/upload-documentos-em-lote.service.model';
import { IVisualizacaoPreviaUploadModalData } from './models/visualizacao-previa-upload.modal.model';

export class VisualizacaoPreviaUploadModalController {
    static $inject = ['$uibModalInstance', 'entity'];

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public entity: IVisualizacaoPreviaUploadModalData,
    ) {}

    formatBytes(bytes: number) {
        return formatBytes(bytes);
    }

    /**
     * Todos os colaboradores da prévia, elegíveis ou não.
     *
     * Só é listado na seleção por trabalhador, onde a lista confirma a escolha que
     * a pessoa fez nome por nome. Na seleção por filtro ela seria só o filtro
     * reescrito em N linhas -- ali valem os contadores e as exceções.
     */
    getTodos(): IUploadDocumentoPreviewTrabalhador[] {
        return this.entity.preview?.trabalhadores || [];
    }

    getElegiveis(): IUploadDocumentoPreviewTrabalhador[] {
        return this.getTodos().filter((item) => item.elegivel);
    }

    getInelegiveis(): IUploadDocumentoPreviewTrabalhador[] {
        return this.getTodos().filter((item) => !item.elegivel);
    }

    /** Quem já tem documento não liberado na mesma chave e vai tê-lo trocado. */
    getSubstituicoes(): IUploadDocumentoPreviewTrabalhador[] {
        return this.getElegiveis().filter((item) => !!item.substitui_documento_anterior);
    }

    temInelegiveis() {
        return this.getInelegiveis().length > 0;
    }

    temSelecaoPorTrabalhador() {
        return this.entity.tipoSelecaoColaboradores === 'trabalhador';
    }

    temSubstituicoes() {
        return (this.entity.preview?.qtd_substituicoes || 0) > 0;
    }

    naoGeraNada() {
        return (this.entity.preview?.qtd_documentos_previstos || 0) === 0;
    }

    isSelecaoPorFiltro() {
        return this.entity.tipoSelecaoColaboradores === 'filtro';
    }

    confirmar() {
        this.$uibModalInstance.close(true);
    }

    close() {
        this.$uibModalInstance.dismiss('cancelar');
    }
}
